import * as React from "react"

import { cn } from "@/lib/utils"

/**
 * MediCare+ text input.
 *
 * 16px text at every breakpoint. That is the spec's body size, and it is also
 * the threshold below which iOS Safari zooms the viewport on focus — a
 * clinician tabbing through a form on a bedside iPad should not have the page
 * jump under them at every field.
 */
function Input({ type, className, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "flex h-11 w-full min-w-0 rounded-lg border-[1.5px] border-input bg-card px-3.5 py-2.5",
        "text-base text-foreground transition-colors",
        "placeholder:text-placeholder selection:bg-primary selection:text-primary-foreground",
        "file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground",
        "focus-ring focus-visible:border-primary",
        "aria-invalid:border-destructive aria-invalid:error-ring",
        "disabled:pointer-events-none disabled:cursor-not-allowed disabled:border-border disabled:bg-muted disabled:opacity-60",
        className
      )}
      {...props}
    />
  )
}

export { Input }
